import React from "react";
import PropTypes from "prop-types";
import Autosuggest from "react-autosuggest";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import {
  MenuItem,
  ListItemText,
  Avatar
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { debounce, find } from "lodash";
import UserStore from "../stores/UserStore";
import extract_user from '../functions/extract'

function renderInput(inputProps) {
  const { classes, disabled, preview, ref, ...other } = inputProps;

  return (
    <TextField
      fullWidth
      inputRef={ref}
      disabled={disabled}
      InputProps={{
        disableUnderline: disabled? true : false,
        classes: {
          input: disabled? preview? classes.preview : classes.input_disabled : classes.input
        },
        ...other
      }}
    />
  );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
  let fullName = suggestion.name.title+' '+suggestion.name.full
  if(suggestion.job_title !== '') fullName += '-('+suggestion.job_title+')'

  const matches = match(fullName, query);
  const parts = parse(fullName, matches);

  return (
    //if there is no photo the assumtion  is a group, when is a user the server MUST return an url
    <MenuItem selected={isHighlighted} component="div" >
        <Avatar alt="avatar" className="avatar">{ suggestion.name.full.slice(0, 2) }</Avatar>
      <ListItemText style={{overflow:'auto'}}
        primary={parts.map((part, i) => {
          return part.highlight ? (
            <span key={String(i)} style={{ fontWeight: 500 }}>
              {part.text}
            </span>
          ) : (
            <strong key={String(i)} style={{ fontWeight: 300 }}>
              {part.text}
            </strong>
          );
        })}
        secondary={(typeof(suggestion.email) !== 'undefined') ?  extract_user(suggestion.email) : ''}
      />
    </MenuItem>
  );
}

function renderSuggestionsContainer(options) {
  const { containerProps, children } = options;

  return (
    <Paper {...containerProps} square style={{ maxHeight: 400, overflowY: 'scroll' }}>
      {children}
    </Paper>
  );
}

function getSuggestionValue(guy) {
  return guy.name.full;
}

const styles = theme => ({
  container: {
    flexGrow: 1,
    position: "relative"
  },
  suggestionsContainerOpen: {
    position: "absolute",
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0
  },
  suggestion: {
    display: "block"
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: "none"
  },
  adornment: {
    whiteSpace: "nowrap",
    '& p':{
      color: "#9e9e9e"
    }
  },
  adornment_disabled: {
    whiteSpace: "nowrap",
    color: "#000",
    '& p':{
      color: "#000"
    }
  },
  input:{
    color: "rgba(0, 0, 0)"
  },
  input_disabled: {
      color: '#000'
  },
  preview:{
    fontSize: 8,
    color: '#000',
    '& p':{
      fontSize: 8,
      color: '#000'
    },
    '& b':{
      fontSize: 8,
      color: '#000'
    }
  }
});

class SearchUserToAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      suggestions: [],
      type: this.props.type
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.to !== this.props.to)
      this.setState({ value: this.props.to.name.full });
  }

  handleSuggestionsFetchRequested = debounce(({ value }) => {

    if(value.length > 2){
      UserStore.search(value, this.props.includeGroups, this.props.type).then(r => {
        this.setState({
          suggestions: r.data
        });
      });
    }

  }, 500);

  onBlur = () => {
    let full = find(this.state.psugges, { name: { full: this.state.value } });
    if (full === undefined) {
      full = find(this.state.suggestions, { name: { full: this.state.value } });
      if (full === undefined) this.setState({ value: ""});
    }
  };

  handleSuggestionsClearRequested = () => {
    this.setState({value: ''})
    this.setState(prev => {
      prev.psugges = prev.suggestions;
      prev.suggestions = [];
      return prev;
    });
  };

  handleChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    });
  };

  changeId = (event, { suggestion }) => {
    const { type } = this.state;
    this.props.onChange(suggestion, type, 'Give');
  };

  render() {
    const { classes } = this.props;

    return (
      <Autosuggest
        theme={{
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion
        }}
        renderInputComponent={renderInput}
        suggestions={this.state.suggestions}
        onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
        renderSuggestionsContainer={renderSuggestionsContainer}
        getSuggestionValue={getSuggestionValue}
        onSuggestionSelected={this.changeId}
        renderSuggestion={renderSuggestion}
        inputProps={{
          classes,
          placeholder: "Buscar Usuario",
          value: this.state.value,
          onChange: this.handleChange,
          disabled: this.props.disabled,
        }}
      />
    );
  }
}
SearchUserToAction.defaultProps = { includeGroups: false };

SearchUserToAction.propTypes = {
  onChange: PropTypes.func.isRequired,
  includeGroups: PropTypes.bool.isRequired
};

export default withStyles(styles)(SearchUserToAction);



// WEBPACK FOOTER //
// ./src/components/SearchUserToAction.js